import { tokens } from "./_tokens.generated";

const FAMILY_RESOLVED: Record<string, string> = {
  SANS: 'var(--font-dm-sans), "DM Sans", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  SERIF: 'var(--font-pt-serif), "PT Serif", Georgia, serif',
  DEVANAGARI:
    'var(--font-hi), "Noto Sans Devanagari", "Nirmala UI", "Kohinoor Devanagari", Mangal, sans-serif',
  DEVANAGARI_BOLD:
    'var(--font-hi), "Noto Sans Devanagari", "Nirmala UI", "Kohinoor Devanagari", Mangal, sans-serif',
};

type VariantValue = {
  fontSize: number;
  lineHeight: number;
  fontWeight: string;
  fontFamily?: string;
  letterSpacing?: number;
  textTransform?: "uppercase" | "lowercase" | "capitalize" | "none";
};

export type WebTypographyStyle = {
  fontSize: number;
  fontWeight: "400" | "500" | "600" | "700" | "800" | "900";
  lineHeight: string;
  fontFamily?: string;
  letterSpacing?: number;
  textTransform?: "uppercase" | "lowercase" | "capitalize" | "none";
};

function resolveVariant(value: VariantValue): WebTypographyStyle {
  const { fontFamily, lineHeight, ...rest } = value;
  return {
    ...rest,
    fontWeight: rest.fontWeight as WebTypographyStyle["fontWeight"],
    lineHeight: `${lineHeight}px`,
    ...(fontFamily ? { fontFamily: FAMILY_RESOLVED[fontFamily] ?? fontFamily } : {}),
  };
}

type WebTypographyScale = {
  [K in keyof typeof tokens.typography.variants]: WebTypographyStyle;
};

export const webTypography = Object.fromEntries(
  Object.entries(tokens.typography.variants).map(([name, value]) => [
    name,
    resolveVariant(value as VariantValue),
  ])
) as WebTypographyScale;

export type WebTypographyVariant = keyof WebTypographyScale;
